import cx from 'classnames';

import { useGGTheme } from 'hooks/theme/useGGTheme';

import { CanvasNavigation } from '../../Navigation/CanvasNavigation';

import s from './../CanvasLayout.module.css';

interface TProps {
  children: React.ReactNode;
}

const CanvasMinimalLayout = ({ children }: TProps) => {
  const { theme } = useGGTheme();

  const isSandPalette = theme && theme.palette.name === 'Sand';
  const isEnergyPalette = theme && theme.palette.name === 'Energy';

  return (
    <div
      className={cx(s.canvas, s.minimalLayout, {
        [s.sandPalette]: isSandPalette,
        [s.energyPalette]: isEnergyPalette,
      })}
    >
      <div className={s.layout}>
        <CanvasNavigation />
        <div className={s.minimalLayoutContent}>{children}</div>
      </div>
    </div>
  );
};

export { CanvasMinimalLayout };
